(() => {
  const bars = [...document.querySelectorAll('[data-shipping-progress]')];
  if (!bars.length) return;
  const currencyFormat = new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: 'USD', currencyDisplay: 'code' });
  const update = cart => {
    const total = cart.total_price;
    const valid = typeof total === 'number' && Number.isSafeInteger(total) && total >= 0;
    bars.forEach(bar => {
      const threshold = Number(bar.dataset.threshold);
      const currency = cart.currency || bar.dataset.currency;
      const usable = valid && Number.isSafeInteger(threshold) && threshold > 0;
      bar.hidden = !usable;
      if (!usable) return;
      const isUSD = currency === 'USD';
      const remaining = Math.max(0, threshold - total);
      const qualified = isUSD && total >= threshold;
      const message = !isUSD ? bar.dataset.nonUsdMessage : qualified ? bar.dataset.qualifiedMessage : total === 0 ? bar.dataset.emptyMessage : bar.dataset.remainingMessage.replace('__AMOUNT__', currencyFormat.format(remaining / 100));
      const text = bar.querySelector('[data-shipping-message]');
      if (text.textContent !== message) text.textContent = message;
      const meter = bar.querySelector('[data-shipping-meter]');
      meter.hidden = !isUSD;
      meter.max = 100;
      meter.value = isUSD ? Math.min(100, total / threshold * 100) : 0;
      meter.setAttribute('aria-valuetext', message);
      bar.dataset.currency = currency;
    });
  };
  document.addEventListener('meanwhile:cart-updated', event => {
    if (event.detail?.cart) update(event.detail.cart);
  });
})();
